var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('brand_tag_help_view_text', { id: _vm.$store.state.chatState.chat && _vm.$store.state.chatState.chat.chat_id || _vm.firstChatWithAtLeastAdvancedId }))}})}
var staticRenderFns = []

export { render, staticRenderFns }